import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
  z-index: 15;
`;

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.CONSTANTS.XR * 5}px;
  width: 100%;
  height: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
`;

export const ButtonIcon = styled.img`
  width: 40px;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  width: 100%;
  align-items: center;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 2}px;

  button {
    width: 75%;
    max-width: 400px;
  }
`;
